import {
  FormControlLabel,
  Checkbox,
  InputLabel,
  TableBody,
  TableCell,
  TableRow,
  Table,
  TableHead,
} from "@mui/material";
import { FC } from "react";
import { CheckBoxOutlined } from "@mui/icons-material";
import { Features } from "../../enum/features";

type PermissionsProps = {
  rolePermissions: string[];
  rolesForm: any;
};

class Entity {
  permissions: any;
  feature: any;
  featureObject: any = Features;
  crudArray = ["Read", "Create", "Update", "Delete"];
  constructor(name: any, index: number) {
    this.feature = name?.name;
    if (this.featureObject?.[index]?.specialPermissions) {
      this.crudArray = this.featureObject?.[index]?.specialPermissions;
    }
    this.permissions = this.crudArray?.map((data) => {
      return {
        value: `${name.name}-${data}`,
        name: data,
      };
    });
  }
  getAssociatedReadPermissions(action: string, parent_index: number) {
    let associatedEntities;
    if (action) {
      associatedEntities =
        this.featureObject?.[parent_index]?.[
        ["Create", "Update"]?.includes(action) ? "Write" : action
        ];
    } else {
      associatedEntities = [
        ...new Set([
          ...(this.featureObject?.[this.feature]?.Write ?? []),
          ...(this.featureObject?.[this.feature]?.Read ?? []),
        ]),
      ];
    }
    this.permissions =
      associatedEntities?.map((data: any) => {
        return `${data}-${this.crudArray[0]}`;
      }) ?? [];
    return this.permissions;
  }
}
// const features = Object.keys(Features);
const features = Features;

const Permissions: FC<PermissionsProps> = ({ rolesForm }) => {
  const handleSelectAll = (entity: any, checked: boolean) => {
    const permissions = entity.permissions.map(
      (permission: any) => permission.value
    );
    if (checked) {
      rolesForm.setValues((prevData: any) => {
        return {
          ...prevData,
          rolePermissions: [
            ...new Set([
              ...prevData.rolePermissions,
              ...permissions,
              ...entity.getAssociatedReadPermissions(""),
            ]),
          ],
        };
      });
    } else {
      rolesForm.setValues((prevData: any) => {
        return {
          ...prevData,
          rolePermissions: prevData?.rolePermissions?.filter(
            (rolePermission: string) => {
              return !permissions.includes(rolePermission);
            }
          ),
        };
      });
    }
    return permissions;
  };

  const isChecked = (feature: string, index: number) => {
    let permissions = new Entity(feature, index).permissions.map(
      (permission: any) => permission.value
    );
    const contains = permissions.every((element: any) => {
      return rolesForm.values.rolePermissions?.indexOf(element) !== -1;
    });
    if (contains) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Table size="small" sx={{ borderCollapse: "separate", borderSpacing: "0px 5px" }}>
      <TableHead>
        <TableRow>
          <TableCell>Feature</TableCell>
          <TableCell>Permissions</TableCell>
          <TableCell>Select All</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {features.map((feature: any, parent_index: number) => {
          const entity = new Entity(feature, parent_index);
          return (
            <TableRow
              key={parent_index}
              className={`tableRow ${isChecked(feature, parent_index) === true &&
                rolesForm?.values?.name === "Owner"
                ? "disabledGrid"
                : ""
                }`}
            >
              <TableCell align="left" sx={{ backgroundColor: "#F4F7F7" }}>
                <InputLabel className="permissionLabel" htmlFor={feature}>
                  {feature.label}
                </InputLabel>
              </TableCell>
              <TableCell align="left" sx={{ backgroundColor: "#F4F7F7" }}>
                {entity?.permissions.map((permission: any, index: number) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        className="checkBox"
                        id={`${feature.name}-${permission}`}
                        checkedIcon={<CheckBoxOutlined />}
                        disableRipple
                        value={permission?.value}
                        name={"rolePermissions"}
                        checked={rolesForm?.values?.rolePermissions?.includes(
                          permission?.value
                        )}
                        readOnly={rolesForm?.values?.rolePermissions?.includes(
                          permission?.value
                        )}
                        onChange={(e) => {
                          if (e.currentTarget.checked) {
                            rolesForm.setValues((prevData: any) => {
                              return {
                                ...prevData,
                                rolePermissions: [
                                  ...new Set([
                                    ...prevData.rolePermissions,
                                    permission?.value,
                                    ...entity?.getAssociatedReadPermissions(
                                      permission?.name, parent_index
                                    ),
                                  ]),
                                ],
                              };
                            });
                          } else {
                            if (e.currentTarget.checked === false) {
                              //
                            }
                            rolesForm?.handleChange(e);
                          }
                        }}
                      />
                    }
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                    }}
                    label={permission.name}
                  />
                ))}
              </TableCell>
              <TableCell align="right" sx={{ backgroundColor: "#F4F7F7" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      className="selectAll"
                      checkedIcon={<CheckBoxOutlined />}
                      disableRipple
                      checked={isChecked(feature, parent_index)}
                      onChange={(e) => {
                        handleSelectAll(entity, e.currentTarget.checked);
                      }}
                    />
                  }
                  label=""
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
export default Permissions;
